import {inject, NgModule} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LoginComponent} from "./modules/login/login.component";
import {ItemsOverviewComponent} from "./modules/items-overview/items-overview.component";
import {TableNumberComponent} from "./modules/table-number/table-number.component";
import {CheckoutComponent} from "./modules/checkout/./checkout.component";
import {CreateWaiterComponent} from "./modules/create-waiter/create-waiter.component";
import {WaiterOverviewComponent} from "./modules/waiter-overview/waiter-overview.component";
import {ReceivedOrdersOverviewComponent} from "./modules/received-orders-overview/received-orders-overview.component";
import {ReceiptsOverviewComponent} from "./modules/receipts-overview/receipts-overview.component";
import {WaiterCheckinCheckoutComponent} from "./modules/waiter-checkin-checkout/waiter-checkin-checkout.component";
import {authGuard} from "./core/auth/auth.guard";
import {ManageItemsComponent} from "./modules/manage-items/manage-items.component";
import {orderGuard} from "./core/auth/order.guard";
import {CancelOrderOverviewComponent} from "./modules/cancel-order-overview/cancel-order-overview.component";
import {CategoryOverviewComponent} from "./modules/category-overview/category-overview.component";
import {PrinterOverviewComponent} from "./modules/printer-overview/printer-overview.component";
import {TenantOverviewComponent} from "./modules/tenant-overview/tenant-overview.component";
import {
  QueueCategoryAssignmentComponent
} from "./modules/queue-category-assignment/queue-category-assignment.component";
import {checkoutBlockGuard} from "./core/auth/checkout-block.guard";
import {canDeactivateGuard} from "./core/auth/can-deactivate.guard";
import {ShowErrorsComponent} from "./modules/show-errors/show-errors.component";

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [checkoutBlockGuard] },
  { path: 'order', component: ItemsOverviewComponent, canActivate: [authGuard, orderGuard], data: { role: 'user' } },
  { path: 'tablenumber', component: TableNumberComponent, canActivate: [authGuard, checkoutBlockGuard], data: { role: 'user' } },
  { path: 'checkout', component: CheckoutComponent, canActivate: [authGuard, checkoutBlockGuard], canDeactivate: [canDeactivateGuard], data: { role: 'user' } },
  { path: 'create-waiter', component: CreateWaiterComponent, canActivate: [authGuard], data: { role: 'admin' } },
  { path: 'waiter-overview', component: WaiterOverviewComponent, canActivate: [authGuard], data: { role: 'admin' } },
  { path: 'orders-overview', component: ReceivedOrdersOverviewComponent, canActivate: [authGuard, checkoutBlockGuard], data: { role: 'user' } },
  { path: 'receipts-overview', component: ReceiptsOverviewComponent, canActivate: [authGuard, checkoutBlockGuard], data: { role: 'user' } },
  { path: 'errors', component: ShowErrorsComponent, canActivate: [authGuard, checkoutBlockGuard], data: { role: 'user' } },
  { path: 'cancel-order-overview', component: CancelOrderOverviewComponent, canActivate: [authGuard], data: {role: 'admin' } },
  { path: 'waiter-checkin-out', component: WaiterCheckinCheckoutComponent, canActivate: [authGuard], data: { role: 'admin' } },
  { path: 'manage-categories', component: CategoryOverviewComponent, canActivate: [authGuard], data: { role: 'admin' } },
  { path: 'manage-items', component: ManageItemsComponent, canActivate: [authGuard], data: { role: 'admin' } },
  { path: 'manage-printer', component: PrinterOverviewComponent, canActivate: [authGuard], data: { role: 'superadmin' } },
  { path: 'manage-tenants', component: TenantOverviewComponent, canActivate: [authGuard], data: { role: 'superadmin' } },
  { path: 'queue-category-assignment', component: QueueCategoryAssignmentComponent, canActivate: [authGuard], data: { role: 'superadmin' } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
